import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { StatusChipComponent } from '@components/status-chip/status-chip.component';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
@Component({
  selector: 'app-item-status-column',
  standalone: true,
  imports: [StatusChipComponent],
  templateUrl: './item-status-column.component.html',
  styleUrl: './item-status-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemStatusColumnComponent implements AgRendererComponent {
  readonly status = signal<number>(-1);

  agInit(params: ICellRendererParams): void {
    this.status.set(params.data.status ?? -1);
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
